import { TXN_TYPES } from '@/application/utils/define';
import { standardTimeToUtcZeroTime } from '@/common/utils/commonUtils';
import { DATABASE_DETAIL_TYPE } from '@/database/adapter/openDetail.define';
import type { DetailParams } from '../types';
import { formatName, parseSchema } from './utils';
import {
  transactionDetailSchema,
  type TransactionDetailSchema,
  type TransactionDetailAddition,
} from './etc.schema';

// DB 구분 안되는 애들
export const getTransactionAddition = ({
  detailInfo,
}: DetailParams): { name: string; transaction: TransactionDetailAddition } => {
  const { data } = parseSchema<TransactionDetailSchema>(
    transactionDetailSchema,
    detailInfo,
    DATABASE_DETAIL_TYPE.TRANSACTION,
  );

  return {
    name: formatName(data.txnName),
    transaction: {
      wasId: data.wasId,
      tid: data.tid,
      txnName: data.txnName,
      collectTime: standardTimeToUtcZeroTime(data.wasCollectTime),
      startTime: '',
      txnType: TXN_TYPES.DB,
    },
  };
};
